import styled from 'styled-components';

// Container principal
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  background: var(--black-color);
`;

// Título da seção
export const SectionTitle = styled.div`
  font-size: 3vw;
  font-weight: bold;
  line-height: 1.2;
  text-align: center;
  color: var(--white-color);
  margin: 0 0 50px 0;
  width: 100%;
  max-width: 800px;

  @media (max-width: 768px) {
    font-size: 6vw;
    margin: 0 0 30px 0;
  }

  @media (min-width: 1200px) {
    font-size: 2.5rem;
  }
`;

// Container dos modos
export const ModosContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  max-width: 1000px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
  }
`;

// Card de cada modo
export const ModoCard = styled.div`
  background: ${props => props.primary
    ? 'linear-gradient(145deg, rgba(255, 153, 0, 0.12), rgba(255, 153, 0, 0.04))'
    : 'linear-gradient(145deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))'};
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: ${props => props.primary
    ? '0 10px 40px rgba(255, 153, 0, 0.2)'
    : '0 10px 30px rgba(0, 0, 0, 0.3)'};
  border: 1.5px solid ${props => props.primary ? 'rgba(255, 153, 0, 0.6)' : 'rgba(255,255,255,0.1)'};
  padding: 30px;
  text-align: center;
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  flex: 1;
  max-width: 450px;

  &:hover {
    transform: translateY(-6px);
    box-shadow: ${props => props.primary
      ? '0 20px 50px rgba(255, 153, 0, 0.3)'
      : '0 20px 40px rgba(0, 0, 0, 0.4)'};
  }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 25px;
  }
`;

// Ícone do modo
export const ModoIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
    margin-bottom: 15px;
  }
`;

// Título do modo
export const ModoTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: bold;
  color: var(--white-color);
  margin: 0 0 15px 0;
  line-height: 1.2;
  text-wrap: balance;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin: 0 0 12px 0;
  }
`;

// Descrição do modo
export const ModoDescription = styled.p`
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.5;
  margin: 0 0 25px 0;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin: 0 0 20px 0;
  }
`;

// Lista de características
export const ModoFeatures = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;

  li {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.65);
    margin-bottom: 10px;
    padding-left: 25px;
    position: relative;
    line-height: 1.4;

    &:before {
      content: "✓";
      position: absolute;
      left: 0;
      top: 2px;
      color: var(--primary-color);
      font-weight: bold;
      font-size: 1.1rem;
    }

    @media (max-width: 768px) {
      font-size: 0.9rem;
      margin-bottom: 8px;
      padding-left: 22px;

      &:before {
        font-size: 1rem;
      }
    }
  }
`;

// Container de personagens
export const PersonagensContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
  flex-wrap: wrap;
`;

// Avatar dos personagens
export const PersonagemAvatar = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center;
  border: 3px solid var(--primary-color);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    border-width: 2px;
  }
`;
